import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Dependencies } from '@adornis/materialized-views/decorators/dependency.js';
import type { Familienstand } from '../../../../db/enums/misc-enums.js';

/**
 * @entity MitarbeiterKind
 */
@Entity()
export class MitarbeiterKind extends AdornisEntity {
  static override _class = 'MitarbeiterKind';

  @Field(() => ID, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(() => String)
  vorname: Maybe<string>;

  @Field(() => String)
  nachname: Maybe<string>;

  @Field(() => Date)
  geburtsdatum: Maybe<Date>;
}

@Entity()
export class ANInfos extends AdornisEntity {
  static override _class = 'ANInfos';

  @Field(() => String)
  geburtsName: Maybe<string>;

  @Field(() => String)
  familienstand: Maybe<Familienstand>;

  @Field(() => Boolean, { default: v => v ?? false })
  hatKinder: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  hatAufenthaltserlaubnis: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  hatArbeitserlaubnis: Maybe<boolean>;

  @Field(() => ID)
  arbeitserlaubnisID: Maybe<string>;

  /** dieses Feld bezieht sich auf die Arbeitserlaubnis */
  @Field(() => Date)
  gueltigAb: Maybe<Date>;

  @Field(() => Date)
  ausstellungsDatumArbeitserlaubnis: Maybe<Date>;

  /** dieses Feld bezieht sich auf die Arbeitserlaubnis */
  @Field(() => Date)
  gueltigBis: Maybe<Date>;

  @Field(() => ID)
  aufenthaltsgenehmigungID: Maybe<string>;

  @Field(() => [MitarbeiterKind], { default: v => v ?? [] })
  kinder: Maybe<MitarbeiterKind[]>;

  @Dependencies({
    classes: () => [],
    ids: () => [],
  })
  @Field(() => Int, {
    resolve: function (this: ANInfos) {
      return () => {
        if (!this.kinder?.length) return 0;
        return this.kinder.filter(k => !!k.vorname && !!k.nachname && !!k.geburtsdatum).length;
      };
    },
  })
  anzahlKinder: Maybe<number>;

  @Field(() => ID)
  elternschaftsnachweisID: Maybe<string>;
}
